// Base URLs
const BACKEND_CONTEXT = "/inventralabs";

const getDefaultBaseUrl = () => {
  if (typeof window === "undefined") {
    return "";
  }

  if (window.location.port === "3000") {
    return `${window.location.protocol}//${window.location.hostname}:8080`;
  }

  return `${window.location.origin}${BACKEND_CONTEXT}`;
};

export const BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || getDefaultBaseUrl()
).replace(/\/$/, "");

//API urls
export const NEW_USER_API = `${BASE_URL}/api/auth/register`;
export const LOGIN_USER_API = `${BASE_URL}/api/auth/login`;
export const LOGIN_GET_USER_PROFILE_API = `${BASE_URL}/api/auth/getProfile`;
export const GET_FULL_EXAM_API = `${BASE_URL}/api/questions/full`;
export const FULL_EXAM_API_UPDATE = `${BASE_URL}/api/mockexams/full-exam/complete`;
export const FETCH_TRAIL_QUESTIONS = `${BASE_URL}/api/questions/trial`;
export const TRIAL_COMPLETED_API_UPDATE = `${BASE_URL}/api/mockexams/trial/complete`;
export const MOCK_EXAM_LIST = `${BASE_URL}/api/mockexamsmaster/getListofExams`;
export const BLOG_COMMENTS_API = (slug) => `${BASE_URL}/api/blogs/${encodeURIComponent(slug)}/comments`;
export const BLOG_COMMENT_LIKE_API = (commentId) => `${BASE_URL}/api/blogs/comments/${commentId}/likes`;
export const BLOG_TOPICS_API = `${BASE_URL}/api/blogs/topics`;

//UPI Payments urls
export const CREATE_ORDER_API = `${BASE_URL}/api/razorpay/create-order`;
export const VERIFY_ORDER_API = `${BASE_URL}/api/razorpay/verify`;
